import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@/icons';
import axios from 'axios';
import { apiPost } from '../../services/api';
import SaveButton from '../../components/common/SaveButton';
import './ConferenciaExportExcelModalContent.css';
import { showAlert } from '../../contexts/DialogContext';
import { Toast } from '../../contexts/ToastContext';
import { logger } from '@/utils/logger';

interface ConferenciaExportExcelModalContentProps {
  theme: 'dark' | 'light';
  onClose: () => void;
  allIdsRascunho: number[];
  allIdsFinalizado: number[];
}

const ConferenciaExportExcelModalContent: React.FC<ConferenciaExportExcelModalContentProps> = ({
  theme,
  onClose,
  allIdsRascunho,
  allIdsFinalizado,
}) => {
  const [selectedStatus, setSelectedStatus] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);

  const handleExport = async () => {
    if (!selectedStatus) {
      await showAlert('Selecione um status para exportar.', { variant: 'warning' });
      return;
    }

    const status = selectedStatus === 'rascunho' ? 'RASCUNHO' : 'FINALIZADO';
    const recebimentoConferenciaIds = selectedStatus === 'rascunho' ? allIdsRascunho : allIdsFinalizado;

    if (!recebimentoConferenciaIds?.length) {
      await showAlert('Nenhum registro encontrado para exportação.', { variant: 'info' });
      return;
    }

    setIsLoading(true);
    try {
      const response = await apiPost(
        '/v1/recebimento-conferencia/export-excel',
        { recebimentoConferenciaIds, status },
        { responseType: 'blob', blocking: true }
      );

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `recebimento-conferencia-${status.toLowerCase()}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      Toast.success('Arquivo Excel gerado com sucesso!');
      onClose();
    } catch (err) {
      logger.error('Erro ao exportar para Excel:', err);
      let errorMessage = 'Erro ao gerar o arquivo Excel. Tente novamente.';
      if (axios.isAxiosError(err)) {
        errorMessage = err.response?.data?.error || errorMessage;
        if (err.response?.status === 400) errorMessage = 'O servidor retornou um erro: formato ou dados inválidos.';
      }
      await showAlert(errorMessage, { variant: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={`conferencia-export-excel-modal-content ${theme}`}>
      <h2>
        <FontAwesomeIcon icon={faFileExcel} /> Exportar para Excel
      </h2>

      <div className="form-group">
        <select
          id="status-select"
          value={selectedStatus}
          onChange={(e) => setSelectedStatus(e.target.value)}
          className="form-select"
        >
          <option value="">Selecione...</option>
          <option value="rascunho">Conferências em Aberto</option>
          <option value="finalizado">Conferências Finalizadas</option>
        </select>
      </div>

      <div className="modal-actions">
        <SaveButton isLoading={isLoading} onClick={handleExport} disabled={!selectedStatus || isLoading} />
      </div>
    </div>
  );
};

export default ConferenciaExportExcelModalContent;
